var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('admin-wrapper',{attrs:{"title-translation-path":"admin.LOCATION_LAB","module-enabler":_vm.moduleEnabler,"has-buttons":false}})}
var staticRenderFns = []

export { render, staticRenderFns }